import { render, staticRenderFns } from "./video.vue?vue&type=template&id=402db819&scoped=true&"
var script = {}
import style0 from "./video.vue?vue&type=style&index=0&id=402db819&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402db819",
  null
  
)

export default component.exports